import { EmploymentQueryProvider } from "__legacy/queries/employments/EmploymentQueryProvider";
import { UpdateEmploymentMutationProvider } from "__legacy/queries/employments/UpdateEmploymentMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { onError, onFinish, UserForm } from "./UserForm";

export const Edit: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <EmploymentQueryProvider variables={{ id }}>
      {({ employment }) => (
        <UpdateEmploymentMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`Edit employment ${employment.user.email}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../")}>Back to list</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <UserForm
                  action="update"
                  form={form}
                  handler={onFinish(mutate, {}, { id })}
                  values={employment}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </UpdateEmploymentMutationProvider>
      )}
    </EmploymentQueryProvider>
  );
};
